import { getEnv } from 'utils/env';
import Pages from './pages';
import OldApp from './oldApp';
import Insights from './insights';

export const Module = {
  OldApp,
  Pages,
  Insights,
};

const config = {
  PUBLIC_URL: getEnv('PUBLIC_URL'),
  APP_VERSION: getEnv('REACT_APP_VERSION'),
  API_SERVICE_ENDPOINT: getEnv('REACT_APP_API_SERVICE_ENDPOINT'),
  PUBLIC_API_SERVICE_ENDPOINT: getEnv(
    'REACT_APP_PUBLIC_API_SERVICE_ENDPOINT',
    'https://api.kontentinoservices.com/public',
  ),
  AJAX_SERVICE_ENDPOINT: getEnv(
    'REACT_APP_AJAX_SERVICE_ENDPOINT',
    window.location.origin,
  ),
  MEDIA_UPLOAD_SERVICE_ENDPOINT: getEnv(
    'REACT_APP_MEDIA_UPLOAD_SERVICE_ENDPOINT',
  ),
  // Dedicated AI Hub URL — historically the standalone AdonisJS
  // ai-hub-service. The runtime mode flag in
  // src/app/config/aiHubEndpointMode.ts picks between this URL and the
  // API gateway mount (`${API_SERVICE_ENDPOINT}/ai-hub`).
  AI_HUB_SERVICE_ENDPOINT: getEnv('REACT_APP_BRAND_HUB_SERVICE_ENDPOINT'),
  BIO_SERVICE_ENDPOINT: getEnv('REACT_APP_BIO_SERVICE_ENDPOINT'),
  ANALYTICS_ENDPOINT: getEnv('REACT_APP_ANALYTICS_ENDPOINT'),
  AI_API_ENDPOINT: getEnv('REACT_APP_AI_API_ENDPOINT'),
  STATIC_URL: getEnv('REACT_APP_STATIC_URL'),
  SCREENSHOT_SERVICE: getEnv('REACT_APP_SCREENSHOT_SERVICE'),
  REPORTS_API_ENDPOINT: getEnv('REACT_APP_REPORTS_API_ENDPOINT'),
  SOCIAL_LOGIN_SERVICE_ENDPOINT: getEnv(
    'REACT_APP_SOCIAL_LOGIN_SERVICE_ENDPOINT',
  ),

  KONTENTINO_HOMEPAGE_URL: 'https://www.kontentino.com',
  KONTENTINO_BLOG_WORDPRESS_API_URL:
    'https://blog.kontentino.com/wp-json/wp/v2/',
  FACEBOOK_SDK_VERSION: 'v3.2',

  REDUX_LOGGER_ON: false,
  REQUEST_LOGGER_ON: true,
  RESPONSE_LOGGER_ON: true,
  USERPILOT_DEBUG_ON: false,
  REACT_QUERY_DEV_TOOLS_ENABLED: false,
  ALL_USER_PERMISSIONS_ENABLED: false,

  // Brand Hub analytics surfaces (Overview tab, Performance tab, Content tab
  // metric cards) are gated while the analytics endpoints get reworked as
  // part of the ai-hub-service → Laravel API migration. Default disabled so
  // prod stays clean; flip ON via env when analytics is wired end-to-end.
  BRAND_HUB_ANALYTICS_ENABLED:
    getEnv('REACT_APP_BRAND_HUB_ANALYTICS_ENABLED') === 'true',

  MODE: getEnv('REACT_APP_MODE') as 'development' | 'production',

  ROUTER_BASE_URL: getEnv('REACT_APP_BASE_ROUTE_URL', '/app'),

  INTERCOM_APP_ID: getEnv('REACT_APP_INTERCOM_APP_ID'),
  FACEBOOK_APP_ID: getEnv('REACT_APP_FACEBOOK_APP_ID'),
  GTM_ID: getEnv('REACT_APP_GTM_ID'),
  USERPILOT_APP_ID: getEnv('REACT_APP_USERPILOT_APP_ID'),
  SENTRY_DSN: getEnv('REACT_APP_SENTRY_DSN'),
  HEAP_ID: getEnv('REACT_APP_HEAP_ID'),
  HOTJAR_ID: getEnv('REACT_APP_HOTJAR_ID'),
  HOTJAR_SNIPPET_VERSION: getEnv('REACT_APP_HOTJAR_SNIPPET_VERSION'),
  BEAMER_PRODUCT_ID: getEnv('REACT_APP_BEAMER_PRODUCT_ID'),
  STRIPE_PUBLISHABLE_KEY: getEnv('REACT_APP_STRIPE_PUBLISHABLE_KEY'),

  COGNITO: {
    userPoolId: getEnv('REACT_APP_COGNITO_USER_POOL_ID'),
    clientId: getEnv('REACT_APP_COGNITO_CLIENT_ID'),
    region: getEnv('REACT_APP_COGNITO_REGION', 'eu-central-1'),
    domain: getEnv('REACT_APP_COGNITO_DOMAIN'),
    externalAuthUrl: getEnv(
      'REACT_APP_EXTERNAL_AUTH_URL',
      'https://auth.kontentino.com',
    ),
  },

  // LOCAL-ONLY dev login. Seeds a synthetic local session so the SPA can be used
  // offline against a locally-bypassed api (see api LocalDevBypassMiddleware).
  // Default OFF; only honored when MODE !== 'production' (see localDevLogin.ts).
  // NOT a security boundary — a non-local api rejects the synthetic token.
  LOCAL_DEV_LOGIN: {
    enabled: getEnv('REACT_APP_LOCAL_DEV_LOGIN') === 'true',
    email: getEnv('REACT_APP_LOCAL_DEV_EMAIL'),
    accountId: Number(getEnv('REACT_APP_LOCAL_DEV_ACCOUNT_ID', '')) || null,
    accountName: getEnv('REACT_APP_LOCAL_DEV_ACCOUNT_NAME'),
  },

  // SECRETS
  KONTENTINO_BLOG_WORDPRESS_USERNAME: getEnv(
    'REACT_APP_KONTENTINO_BLOG_WORDPRESS_USERNAME',
  ),
  KONTENTINO_BLOG_WORDPRESS_PASSWORD: getEnv(
    'REACT_APP_KONTENTINO_BLOG_WORDPRESS_PASSWORD',
  ),
};

export default config;
